<template>
  <button
    @click="handleClick"
    :class="[buttonSize, buttonType, { disabled: disabled }]"
    class="text-base font-medium rounded border transition-all flex gap-2 items-center justify-center"
    :disabled="disabled"
  >
    <component :is="icon" v-if="icon" />
    {{ buttonText }}
  </button>
</template>
<script>
export default {
  props: {
    buttonText: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "primary"
    },
    size: {
      type: String,
      default: "regular"
    },
    icon: Function
  },
  data: () => ({
    buttonClass: {
      primary:
        "bg-primary-400 text-white border-primary-400 hover:bg-primary-700 hover:border-primary-700",
      secondary:
        "bg-transparent border-primary-400 text-primary-400 hover:border-primary-700 hover:text-primary-700",
      delete: "bg-system-error text-white border-system-error",
      success: "bg-system-success text-white border-system-success"
    },
    buttonCLassSize: {
      full: "w-full py-2 px-6",
      regular: "py-2 px-6",
      small: "py-1 px-3",
      big: "text-base py-3 px-6",
      big_full: "w-full text-base py-3 px-6"
    }
  }),
  computed: {
    buttonType() {
      return this.buttonClass[this.type]
    },
    buttonSize() {
      return this.buttonCLassSize[this.size]
    }
  },
  methods: {
    handleClick() {
      this.$emit("action")
    }
  }
}
</script>
<style lang="scss" scoped>
.disabled {
  background-color: #d6d6d6;
  color: #fff;
  border-color: #d6d6d6;
  cursor: not-allowed;
}
</style>
